import React, { useState, useCallback } from 'react';
import PhoneInput from 'antd-phone-input';

/**
 * PhoneInput wrapper that always defaults to the US flag.
 * When the user clears the field completely, the underlying library
 * falls back to timezone-based country detection. This wrapper
 * forces a remount (via key) so country="us" re-initialises.
 */
const PhoneInputUS = React.forwardRef(({ onChange, ...props }, ref) => {
  const [resetKey, setResetKey] = useState(0);

  const handleChange = useCallback((value, event) => {
    if (!value.countryCode && !value.areaCode && !value.phoneNumber) {
      setResetKey(k => k + 1);
    }
    if (onChange) onChange(value, event);
  }, [onChange]);

  return (
    <PhoneInput
      key={resetKey}
      ref={ref}
      country="us"
      {...props}
      onChange={handleChange}
    />
  );
});

export default PhoneInputUS;
